import axios from 'axios';

const instance = axios.create({
 baseURL: 'http://127.0.0.1:5001/fir-d0fad/us-central1/api'// The API(cloud function)URL for local host
});

export default instance;